const planAndPricingPageURL={
    "xrlab360":"https://www.xrlab360.com/plan",
}
export const getPlanAndPricingPageURL = (productName) => {
    return planAndPricingPageURL[productName]
}